import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUsersArray
} from '../redux/usersNotInBoard'

type Payload = {
  boardId: number;
  userIds: number[];
}

const fetchUsersNotInBoard = (payload: Payload) => async dispatch => {
  let { boardId, userIds } = payload

  try {
    const userNotInBoardIds = await apiGetData('UsersNotInBoard', {
      boardId,
      userIds,
    })

    const userArray: any[] = []
    userIds.forEach(userId => {
      if (userNotInBoardIds.indexOf(userId) >= 0) {
        userArray.push({
          id: userId,
          isInBoard: false
        })
      } else {
        userArray.push({
          id: userId,
          isInBoard: true
        })
      }
    })

    dispatch(addUsersArray({
      boardId,
      array: userArray
    }))
  } catch (error) {}
}


export default fetchUsersNotInBoard